import { Clock } from 'lucide-react';
import { css } from 'styled-system/css';

export function RoutineRow({ name, when }: { name: string; when: string }) {
  return (
    <div
      className={css({
        paddingBlock: '3',
        borderBottom: '1px solid token(colors.border.hairline)',
      })}
    >
      <div
        className={css({
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '3',
        })}
      >
        <span
          className={css({
            fontSize: 'xs',
            color: 'text.primary',
            fontWeight: 'medium',
          })}
        >
          {name}
        </span>
        <span
          className={css({
            display: 'flex',
            color: 'text.faint',
            '& > svg': { width: '12px', height: '12px' },
          })}
        >
          <Clock strokeWidth={2} />
        </span>
      </div>
      <p
        className={css({
          margin: 0,
          marginTop: '1',
          fontFamily: 'mono',
          fontSize: '2xs',
          color: 'text.muted',
        })}
      >
        {when}
      </p>
    </div>
  );
}
